import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue";
import Dialog from 'primevue/dialog';
import DynamicIcon from '@apparatix/icons/DynamicIcon.vue';
import CloseIcon from '@apparatix/icons/CloseIcon.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Modal',
    props: {
        visible: { type: Boolean },
        title: {},
        subtitle: {},
        disableFooter: { type: Boolean },
        icon: {},
        position: {},
        onClose: { type: Function },
        padding: {}
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(Dialog), {
                visible: _ctx.visible,
                position: _ctx.position,
                modal: "",
                pt: {
                    root: {
                        style: {
                            boxShadow: 'none',
                            borderRadius: '16px',
                            border: 'none'
                        }
                    }
                }
            }, {
                container: _withCtx(() => [
                    _createElementVNode("div", {
                        class: _normalizeClass(_ctx.$style['modal-container'])
                    }, [
                        _createElementVNode("div", {
                            class: _normalizeClass(_ctx.$style.header)
                        }, [
                            _renderSlot(_ctx.$slots, "header", {}, () => [
                                (_ctx.icon)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: _normalizeClass(_ctx.$style['header-icon'])
                                    }, [
                                        _createVNode(DynamicIcon, {
                                            name: _ctx.icon,
                                            color: "#2FA3EE"
                                        }, null, 8, ["name"])
                                    ], 2))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", {
                                    class: _normalizeClass(_ctx.$style['title-wrapper'])
                                }, [
                                    _createElementVNode("h1", {
                                        class: _normalizeClass(_ctx.$style['title'])
                                    }, _toDisplayString(_ctx.title), 3),
                                    (_ctx.subtitle)
                                        ? (_openBlock(), _createElementBlock("span", {
                                            key: 0,
                                            class: _normalizeClass(_ctx.$style.subtitle)
                                        }, _toDisplayString(_ctx.subtitle), 3))
                                        : _createCommentVNode("", true),
                                    (_ctx.title && !_ctx.subtitle)
                                        ? (_openBlock(), _createElementBlock("span", {
                                            key: 1,
                                            class: _normalizeClass(_ctx.$style.subtitle)
                                        }, " ", 2))
                                        : _createCommentVNode("", true)
                                ], 2),
                                _createElementVNode("div", {
                                    class: _normalizeClass(_ctx.$style['close-button']),
                                    onClick: _cache[0] || (_cache[0] =
                                        //@ts-ignore
                                        (...args) => (_ctx.onClose && _ctx.onClose(...args)))
                                }, [
                                    _createVNode(CloseIcon)
                                ], 2)
                            ])
                        ], 2),
                        _createElementVNode("div", {
                            class: _normalizeClass(_ctx.$style.body),
                            style: _normalizeStyle({ padding: _ctx.padding + 'px' })
                        }, [
                            _renderSlot(_ctx.$slots, "body")
                        ], 6),
                        (!_ctx.disableFooter)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass(_ctx.$style.footer)
                            }, [
                                _renderSlot(_ctx.$slots, "footer")
                            ], 2))
                            : _createCommentVNode("", true)
                    ], 2)
                ]),
                _: 3
            }, 8, ["visible", "position"]));
        };
    }
});
